import * as React from 'react';
import { Helmet } from 'react-helmet';

import './styles.scss';
import Icon from '../../Components/Icon';

export interface IFrameLoginProps {
    /** Page title */
    title: string;
}

interface IState {
}

export default class FrameLogin extends React.Component<IFrameLoginProps, IState> {
    static displayName: string = 'FrameLogin';

    componentDidMount () {
        const doc = document.documentElement;
        if (doc) {
            doc.classList.add('global-frame-login');
        }
    }

    componentWillUnmount () {
        const doc = document.documentElement;
        if (doc) {
            doc.classList.remove('global-frame-login');
        }
    }

    render () {
        return (
            <div className="frame-login">
                <Helmet>
                    <title>{this.props.title}</title>
                </Helmet>
                <div className="frame-login-content">
                    <div className="col">
                        <Icon width={100} height={100} kind="logo"/>
                    </div>
                    <div className="col">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}
